import { useCallback, useEffect, useState } from "react";

const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61589830890787";
const INSTAGRAM_URL = "https://www.instagram.com/mc_denica_montana/";

export default function SocialWelcomeModal() {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEsc = (e) => {
      if (e.key === "Escape") handleClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleEsc);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, handleClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  return (
    <div
      className="modal-backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="modal-content modal-content--social"
        role="dialog"
        aria-modal="true"
        aria-labelledby="social-welcome-modal-title"
      >
        <button
          type="button"
          className="modal-close"
          onClick={handleClose}
          aria-label="Затвори"
        >
          ×
        </button>

        <h2 id="social-welcome-modal-title" className="modal-title">
          Вече сме в социалните мрежи!
        </h2>

        <p className="modal-message">
          Следвайте Медицински център „Деница“, Монтана за новини, събития и
          актуална информация.
        </p>

        <ul className="modal-social-links">
          <li>
            <a
              className="modal-social-links__item modal-social-links__item--facebook"
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="modal-social-links__icon" aria-hidden="true">
                <i className="flaticon-facebook-app-symbol" />
              </span>
              <span className="modal-social-links__label">
                МЦ „Деница“ ООД Монтана
              </span>
            </a>
          </li>
          <li>
            <a
              className="modal-social-links__item modal-social-links__item--instagram"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="modal-social-links__icon" aria-hidden="true">
                <i className="flaticon-instagram" />
              </span>
              <span className="modal-social-links__label">@mc_denica_montana</span>
            </a>
          </li>
        </ul>

        <button type="button" className="modal-button" onClick={handleClose}>
          Разбрах
        </button>
      </div>
    </div>
  );
}
